
































import { Partner } from '@/modules/kartoteka/partner';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';
import { types } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMapper(): Record<string, string> {
			return {
				zakaznik: `${this.storeUri}/${types.mutations.PNV_ZAKAZNIK_LIST_MAPPER}`,
				prodejcepr: `${this.storeUri}/${types.mutations.PNV_PRACOVNIK_LIST_MAPPER}`,
			};
		},
		ZakaznikFilter() {
			return {
				ZakaznikId: this.ZakaznikId,
			};
		},
	},
});
